// The mark a directory item wears in DirIcon. Kept apart from the renderer so
// anything (a test, a server-built node) can ask without pulling the SVGs in.

/** the three marks a directory item wears */
export type DirMark = "folder" | "page" | "skill";

/** The mark an OsNode wears: its `icon`, except a page carrying the skill
 *  modifier (`mark: "skill"`, set by the tree for `kind: skill` pages), which
 *  wears the skill mark: the page with its fold turned into a spark
 *  (law_skill_class). The node itself stays a page everywhere else. */
export function dirMark(n: { icon: "folder" | "page"; mark?: "skill" }): DirMark {
  return n.icon === "page" && n.mark === "skill" ? "skill" : n.icon;
}
